import { useAtom } from 'jotai';
import { SinglePackageHeaderFieldsFragment } from '../../@types/generated';
import { Heading, Paragraph, Subheading } from '../../../../packages/components/src/typography';
import { ImageWithFocalPoint } from './ImageWithFocalPoint';
import Button, { variantFromString } from 'components/src/button';
import TextWithInlineColor from './TextWithInlineColor';
import ISKFormat from './common/ISKFormat';
import { PAKKAFORM_ID } from '@/config/constants';
import { basePriceAtom, isPackageFormOpenAtom } from '@/store';
import MediaBackground from './MediaBackground';

type SinglePackageHeaderProps = {
  data: SinglePackageHeaderFieldsFragment;
};

const SinglePackageHeader = ({ data }: SinglePackageHeaderProps) => {
  const [price] = useAtom(basePriceAtom);
  const [, setIsFormVisible] = useAtom(isPackageFormOpenAtom);

  return (
    <div className="mb-32 grid gap-y-32 text-black-100 md:pt-64">
      {data.mediaVideo?.url && data.mainImage?.id ? (
        <div className="absolute inset-0 z-10 h-full w-full">
          <div className="absolute inset-0 z-10"></div>
          <MediaBackground urlLink={data.mediaVideo.url} />
        </div>
      ) : (
        data.mainImage &&
        data.mainImage?.id && (
          <div className="absolute inset-0 z-10 h-full w-full">
            <div className="absolute inset-0 z-10"></div>
            <ImageWithFocalPoint image={data.mainImage} sectionId={data.mainImage.id} priority />
          </div>
        )
      )}

      <div className="z-20 col-span-full mx-24 flex flex-col gap-y-16 justify-self-center pt-160 md:px-56">
        <TextWithInlineColor
          containerClasses="text-center"
          heading={data.heading?.text?.json}
          color={data.heading?.color}
          textColor={'white-75'}
          headingVariant="xl"
        />
        {data.subHeading && (
          <Subheading classes="text-center text-white-75" bold>
            {data.subHeading}
          </Subheading>
        )}
        {data?.description && (
          <Subheading classes="text-center text-white-75" small>
            {data.description}
          </Subheading>
        )}
        {price > 0 && (
          <div className="col-span-full grid grid-flow-col place-content-center items-baseline gap-x-8">
            <ISKFormat
              value={price}
              renderText={(value) => (
                <Heading classes="display-sm text-white-75" variant="small">
                  {value}
                </Heading>
              )}
            />
            <Paragraph classes="mb-4 text-white-75">{'/mán'}</Paragraph>
          </div>
        )}
      </div>
      {data.pantaButton && data.pantaButton.label && (
        <div className="z-20 col-span-full w-full justify-self-center md:w-[152px]">
          <Button
            label={data.pantaButton?.label}
            variant={variantFromString(data.pantaButton.variant)}
            autoWidth={false}
            onClick={(e) => {
              e.preventDefault();
              const targetElement = document.getElementById(PAKKAFORM_ID);
              if (targetElement) {
                setIsFormVisible(true);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SinglePackageHeader;
